<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Customers Report</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="nav-icon fas fa-users" style="font-size:50px"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Customers Served</p>
              <p class="text-primary text-24 line-height-1 mb-2">205</p>
            </div>
          </div>
        </div>
      </div>
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i
              class="nav-icon fas fa-money-bill-wave"
              style="font-size:50px"
            ></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Contribution Amount</p>
              <p class="text-primary text-24 line-height-1 mb-2">$55,675</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input class="form-control" type="date" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input class="form-control" type="date" />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label><b>Takaful Class</b></label>
                <select class="form-control">
                  <option>All</option>
                  <option>Fire</option>
                  <option>Motor</option>
                  <option>Miscellaneous</option>
                </select>
              </div>
              <div class="col-6">
                <label><b>Takaful Schema</b></label>
                <select class="form-control">
                  <option>All</option>
                  <option>Musafir</option>
                  <option>Private Motor</option>
                  <option>Basic Fire</option>
                </select>
              </div>
              <div class="col-6">
                <label><b>Status</b></label>
                <select class="form-control">
                  <option>All</option>
                  <option>New</option>
                  <option>In Process</option>
                  <option>Completed</option>
                </select>
              </div>
            </div>
            <br />

            <div class="table-responsive">
              <table
                id="new_transaction1"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: left;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Phone Number</th>
                    <th>Email</th>
                    <th>Schemes Purchased</th>
                    <th>Schemes Active</th>
                    <th>Amount Contributed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>
                      <router-link to="">
                        <span class="item-name">John Doe</span>
                      </router-link>
                    </td>
                    <td>6738888888</td>
                    <td>John@Doe.com</td>
                    <td>5</td>
                    <td>2</td>
                    <td>$150.00</td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Jane Doe</td>
                    <td>6738888888</td>
                    <td>Jane@Doe.com</td>
                    <td>10</td>
                    <td>2</td>
                    <td>$150.00</td>
                  </tr>

                  <tr>
                    <td>3</td>
                    <td>James Doe</td>
                    <td>6738888888</td>
                    <td>James@Doe.com</td>
                    <td>3</td>
                    <td>1</td>
                    <td>$150.00</td>
                  </tr>

                  <tr>
                    <td>4</td>
                    <td>Jorah Doe</td>
                    <td>6738888888</td>
                    <td>Jorah@Doe.com</td>
                    <td>3</td>
                    <td>0</td>
                    <td>$150.00</td>
                  </tr>

                  <tr>
                    <td>5</td>
                    <td>Jill Doe</td>
                    <td>6738888888</td>
                    <td>Jill@Doe.com</td>
                    <td>10</td>
                    <td>3</td>
                    <td>$150.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "report-customers",
  components: {},
  mounted() {
    $("#new_transaction1").DataTable({
      dom: "Bfrtip",
      lengthMenu: [
        [10, 25, 50, -1],
        ["10 rows", "25 rows", "50 rows", "Show all"]
      ],
      buttons: ["pageLength", "colvis", "csv", "excel", "pdf", "print"]
    });
  },
  methods: {}
};
</script>
